import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../ThemeContext';
import { Button, Spinner, Alert } from 'react-bootstrap';
import SalesFeed from '../SalesFeed';

const sbVkVideos = [
    { id: 'ios', title: 'Как установить на iOS', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239401&hd=2' },
    { id: 'android', title: 'Как установить на Android', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239402&hd=2' },
    { id: 'auth', title: 'Как авторизоваться', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239403&hd=2' },
    { id: 'feed', title: 'Элементы ленты скидок', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239404&hd=2' },
    { id: 'filters', title: 'Объяснение фильтров', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239405&hd=2' },
    { id: 'watchlist', title: 'Объяснение листа отслеживания', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239406&hd=2' },
];

const VideoStripe = () => (
    <section className="sb-vids" aria-labelledby="sb-vids-title">
        <div className="sb-vids-head">
            <span className="sb-badge">Видео</span>
            <h2 id="sb-vids-title" className="sb-vids-title">Быстрые подсказки</h2>
            <Link to="/videos" className="sb-vids-all">Смотреть все →</Link>
        </div>

        <div className="sb-vids-row" role="list">
            {sbVkVideos.map(v => (
                <article className="sb-vid" key={v.id} role="listitem">
                    <div className="sb-vid-embed">
                        <iframe
                            className="sb-vid-iframe"
                            src={`${v.src}&autoplay=0`}
                            title={v.title}
                            loading="lazy"
                            allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                            allowFullScreen
                        />
                    </div>
                    <h3 className="sb-vid-title">{v.title}</h3>
                </article>
            ))}
        </div>
    </section>
);
function useContainerWidth() {
    const ref = React.useRef(null);
    const [w, setW] = React.useState(0);
    React.useEffect(() => {
        if (!ref.current) return;
        const ro = new ResizeObserver((entries) => {
            for (const e of entries) setW(e.contentRect.width);
        });
        ro.observe(ref.current);
        return () => ro.disconnect();
    }, []);
    return [ref, w];
}

const YesterdayInline = () => {
    const [salesData, setSalesData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [boxRef, boxWidth] = useContainerWidth();

    React.useEffect(() => {
        const ctrl = new AbortController();
        (async () => {
            try {
                setLoading(true);
                const res = await fetch('https://pandoras-box.salew-bot.ru/get_yesterday_sales?days=1', { signal: ctrl.signal });
                const data = await res.json();
                if (data.status && data.data_sale) setSalesData(data.data_sale);
                else setError('Не удалось загрузить данные о скидках');
            } catch (e) {
                if (e.name !== 'AbortError') setError('Ошибка подключения');
            } finally {
                setLoading(false);
            }
        })();
        return () => ctrl.abort();
    }, []);

    return (
        <section className="sb-yday" aria-labelledby="sb-yday-title" ref={boxRef}>
            <div className="sb-yday-head">
                <span className="sb-badge">За вчера</span>
                <h2 id="sb-yday-title" className="sb-yday-title">Вчерашние скидки</h2>
                <Link to="/yesterday-sales" className="sb-vids-all">Все →</Link>
            </div>

            <div className="sb-yday-feed">
                {loading ? (
                    <div className="sb-yday-loading">
                        <Spinner animation="border" size="sm" /> <span>Загрузка…</span>
                    </div>
                ) : error ? (
                    <Alert variant="danger" className="mb-0">{error}</Alert>
                ) : (
                    // ВАЖНО: новый режим и передаём ширину контейнера
                    <SalesFeed sales={salesData} type="main" containerWidth={boxWidth} />
                )}
            </div>
        </section>
    );
};


const PublicLanding = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const navigate = useNavigate();
    const goLogin = () => navigate('/login');

    return (
        <div className={`sb-root ${isDark ? 'sb-dark' : 'sb-light'} scrollable`}>
            <style>{`
        :root{
          --sb-maxw: 87.5rem;
          --sb-bg-light:#f5f7fb; --sb-bg-dark:#0b0f19;
          --sb-heading-light:#0f172a; --sb-heading-dark:#fff;
          --sb-text-light:#1f2937; --sb-text-dark:#e5e7eb;
          --sb-muted-light:#475569; --sb-muted-dark:#9aa4b2;
          --sb-accent:#7c3aed; --sb-accent-2:#22d3ee;
          --sb-border:rgba(255,255,255,0.12);
          --sb-section-bg-light:rgba(255,255,255,0.7);
          --sb-section-bg-dark:rgba(15,23,42,0.4);
        }

        /* base */
        .sb-root{min-height:100vh;display:flex;flex-direction:column;overflow-y:auto}
        .sb-light{background:var(--sb-bg-light);color:var(--sb-text-light)}
        .sb-dark{background:var(--sb-bg-dark);color:var(--sb-text-dark)}

        /* header */
        .sb-header{position:sticky;top:0;z-index:10;display:flex;align-items:center;justify-content:space-between;padding:14px 22px;border-bottom:1px solid var(--sb-border)}
        .sb-light .sb-header{background:rgba(255,255,255,.9);backdrop-filter:blur(8px)}
        .sb-dark .sb-header{background:rgba(0,0,0,.35);backdrop-filter:blur(8px)}
        .sb-logo{display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit;font-weight:800;letter-spacing:.2px;font-size:18px}
        .sb-logo-img{width:36px;height:36px;border-radius:8px;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));flex:0 0 36px}
        .sb-nav{display:flex;align-items:center;gap:10px}
        .sb-link-btn{display:inline-flex;align-items:center;gap:8px;text-decoration:none;font-weight:600;padding:9px 14px;border-radius:12px;color:inherit;border:1px solid var(--sb-border);background:transparent;transition:transform .12s ease,border-color .2s ease}
        .sb-link-btn:hover{transform:translateY(-1px);border-color:rgba(124,58,237,.45)}

        /* hero */
        .sb-hero{display:grid;grid-template-columns:.75fr 1.35fr;gap:0;align-items:center;padding:36px 22px 18px;max-width:var(--sb-maxw);margin:0 auto;width:100%}
        .sb-title{font-size:clamp(28px,3.6vw,54px);line-height:1.1;font-weight:900;letter-spacing:-.4px;color:var(--sb-heading-light);margin:0 0 16px}
        .sb-dark .sb-title{color:var(--sb-heading-dark)}
        .sb-sub{font-size:clamp(16px,1.4vw,20px);line-height:1.65;color:var(--sb-muted-light);margin:0 0 24px}
        .sb-dark .sb-sub{color:var(--sb-muted-dark)}
        .sb-cta-row{display:flex;flex-wrap:wrap;gap:12px;margin-top:8px}

        /* art */
        .sb-art{display:grid;place-items:center}
        .sb-art-inner{position:relative;width:min(100%,680px);aspect-ratio:4/3;border-radius:22px;overflow:hidden}
        .sb-art img{width:100%;height:100%;object-fit:contain;background:transparent;display:block}

        /* benefits (left big + 3 right) */
        .sb-benefits{max-width:var(--sb-maxw);width:100%;margin:12px auto 32px;padding:0 22px}
        .sb-benefits-head{display:flex;align-items:center;gap:10px;margin:0 0 14px}
        .sb-badge{padding:6px 10px;border-radius:999px;font-weight:700;font-size:12px;letter-spacing:.3px;color:#fff;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2))}
        .sb-benefits-title{margin:0;font-weight:900;font-size:clamp(20px,2.4vw,28px);color:var(--sb-heading-light)}
        .sb-dark .sb-benefits-title{color:var(--sb-heading-dark)}
        .sb-benefits-grid{display:grid;grid-template-columns:1.15fr 0.85fr;grid-template-rows:auto auto auto;grid-template-areas: "main aside1" "main aside2" "full full";gap:18px}
        .sb-card{border:1px solid var(--sb-border);border-radius:16px;background:var(--sb-section-bg-light);padding:18px 16px}
        .sb-dark .sb-card{background:var(--sb-section-bg-dark)}
        .sb-card-title{display:flex;align-items:center;gap:10px;margin:0 0 12px;font-weight:900;font-size:clamp(18px,2.2vw,24px);color:var(--sb-heading-light)}
        .sb-dark .sb-card-title{color:var(--sb-heading-dark)}
        .sb-dot{width:10px;height:10px;border-radius:50%;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));flex:0 0 10px}
        .sb-bullets{margin:0;padding:0;list-style:none;display:grid;gap:10px;font-size:15.5px;line-height:1.5;color:var(--sb-muted-light)}
        .sb-dark .sb-bullets{color:var(--sb-muted-dark)}
        .sb-right-stack{display:grid;gap:18px}
        .sb-card--main{ position:relative; padding-left:22px; }
        .sb-card--main::before{
        content:""; position:absolute; inset:0 auto 0 0; width:6px;
        border-radius:16px 0 0 16px;
        background:linear-gradient(180deg,var(--sb-accent),var(--sb-accent-2));
        opacity:.9;
        }
        .sb-card--main { grid-area: main; }
        .sb-card--aside1 { grid-area: aside1; }
        .sb-card--aside2 { grid-area: aside2; }
        .sb-card--full  { grid-area: full; }
        /* footer */
        .sb-footer{opacity:.75;font-size:13px;padding:18px 22px 28px;text-align:center;margin-top:auto}

        /* responsive */
        @media (min-width:1100px){
            .sb-bullets--2col{
                display:grid; grid-template-columns:1fr 1fr; gap:10px 24px;
            }
        }
        .sb-li{ display:grid; grid-template-columns:18px 1fr; align-items:flex-start; gap:10px; }
        .sb-li i{
        width:18px; height:18px; border-radius:50%;
        background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));
        display:block; margin-top:3px;
        }
        .sb-chips{ display:flex; flex-wrap:wrap; gap:8px; margin-top:12px; }
        .sb-chip{
        font-size:12px; font-weight:700; letter-spacing:.2px;
        padding:6px 10px; border-radius:999px;
        background:rgba(124,58,237,.12); border:1px solid rgba(124,58,237,.25);
        }
        .sb-dark .sb-chip{ background:rgba(124,58,237,.18); border-color:rgba(124,58,237,.35); }

        /* правая колонка — обычные одно-колоночные списки */
        .sb-right-stack{ display:contents; }

        /* правая колонка — стек карточек */
        .sb-right-stack{ display:contents; }
        @media (max-width:992px){
          .sb-hero{grid-template-columns:1fr;gap:28px;padding-top:22px}
          .sb-title,.sb-sub{text-align:center}
          .sb-cta-row{justify-content:center}
          .sb-benefits{padding:0 16px}
          .sb-benefits-grid{
    grid-template-columns:1fr;
    grid-template-areas:
      "main"
      "aside1"
      "aside2"
      "full";
  }
        }
        @media (max-width:768px){
          .sb-header{padding:12px 16px}
          .sb-logo span{font-size:16px}
          .sb-nav .sb-link-btn{display:none}
          .sb-hero{padding:24px 16px}
          .sb-cta-row{flex-direction:column;align-items:center}
          .sb-cta-row .btn,.sb-cta-row .sb-link-btn{width:100%;text-align:center;justify-content:center}
        }
          .sb-vids{ max-width:var(--sb-maxw); width:100%; margin:8px auto 24px; padding:0 22px; }
.sb-vids-head{ display:flex; align-items:center; gap:10px; margin:0 0 10px; }
.sb-vids-title{ margin:0; font-weight:900; font-size:clamp(18px,2.2vw,24px); color:var(--sb-heading-light); }
.sb-dark .sb-vids-title{ color:var(--sb-heading-dark); }
.sb-vids-all{ margin-left:auto; font-weight:800; font-size:14px; opacity:.8; text-decoration:none; }
.sb-vids-all:hover{ opacity:1; }

.sb-vids-row{
  display:grid;
  grid-auto-flow: column;
  grid-auto-columns: 190px;     /* ширина карточки */
  gap:12px;
  overflow-x:auto;
  padding-bottom:8px;
  scroll-snap-type:x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width:none;
}
.sb-vids-row::-webkit-scrollbar{ display:none; }

.sb-vid{
  border:1px solid var(--sb-border);
  border-radius:16px;
  background:var(--sb-section-bg-light);
  padding:10px;
  scroll-snap-align: start;
}
.sb-dark .sb-vid{ background:var(--sb-section-bg-dark); }

.sb-vid-embed{ position:relative; width:100%; aspect-ratio:9/16; border-radius:10px; overflow:hidden; background:#000; }
.sb-vid-iframe{ position:absolute; inset:0; width:100%; height:100%; border:0; }

.sb-vid-title{ margin:8px 2px 0; font-size:13px; font-weight:800; line-height:1.35; color:var(--sb-heading-light); }
.sb-dark .sb-vid-title{ color:var(--sb-heading-dark); }

/* адаптивные размеры карточек */
@media (min-width:1280px){ .sb-vids-row{ grid-auto-columns: 265px; } }  /* на широких — чуть шире */
@media (max-width:720px){
  .sb-vids{ padding:0 16px; }
  .sb-vids-row{ grid-auto-columns: 265px; gap:10px; }
}
  .sb-yday{ max-width:var(--sb-maxw); width:100%; margin:8px auto 28px; padding:0 22px; }
.sb-yday-head{ display:flex; align-items:center; gap:10px; margin:0 0 10px; }
.sb-yday-title{ margin:0; font-weight:900; font-size:clamp(18px,2.2vw,24px); color:var(--sb-heading-light); }
.sb-dark .sb-yday-title{ color:var(--sb-heading-dark); }
.sb-yday-feed{ border:1px solid var(--sb-border); border-radius:16px; background:var(--sb-section-bg-light); }
.sb-dark .sb-yday-feed{ background:var(--sb-section-bg-dark); }
.sb-yday-loading{ display:flex; align-items:center; gap:8px; padding:16px; font-weight:600; opacity:.85; }

/* на мобиле — те же поля, чуть уже */
@media (max-width:720px){
  .sb-yday{ padding:0 16px; }
}
      `}</style>

            {/* header */}
            <header className="sb-header">
                <Link className="sb-logo" to="/">
                    <img className="sb-logo-img" src="android-icon-36x36.png" alt="Salew Bot" width={36} height={36} />
                    <span>Salew Bot</span>
                </Link>
                <div className="sb-nav">
                    <Link className="sb-link-btn" to="/yesterday-sales">Вчерашние скидки</Link>
                    <Button variant="primary" onClick={goLogin} style={{ borderRadius: 12, padding: '10px 16px', fontWeight: 700 }}>
                        Авторизация
                    </Button>
                </div>
            </header>

            {/* hero */}
            <main className="sb-hero" role="main">
                <div>
                    <h1 className="sb-title">Сэкономьте на следующей покупке</h1>
                    <p className="sb-sub">
                        <strong>Salew Bot</strong> — сервис отслеживания цен на Wildberries, Ozon и «Детском мире».
                        Мы мгновенно оповещаем о выгодных предложениях на товары, которые вам нравятся.
                    </p>
                    <div className="sb-cta-row">
                        <Button variant="primary" size="lg" onClick={goLogin} style={{ borderRadius: 14, fontWeight: 800 }}>
                            Авторизация
                        </Button>
                        <Link to="/yesterday-sales" className="sb-link-btn" style={{ padding: '12px 16px', fontWeight: 700 }}>
                            Посмотреть вчерашние скидки
                        </Link>
                    </div>
                </div>

                <div className="sb-art">
                    <div className="sb-art-inner">
                        <img src="backall.png" alt="Лучшие скидки и предложения" loading="eager" />
                    </div>
                </div>
            </main>

            {/* benefits */}
            <section className="sb-benefits" aria-labelledby="benefits-heading">
                <div className="sb-benefits-head">
                    <span className="sb-badge">Что входит</span>
                    <h2 id="benefits-heading" className="sb-benefits-title">Всё для реальной экономии</h2>
                </div>

                <div className="sb-benefits-grid">
                    {/* Левый основной блок — на две строки */}
                    <article className="sb-card sb-card--main">
                        <h3 className="sb-card-title">Удобное PWA-приложение</h3>
                        <ul className="sb-bullets sb-bullets--2col">
                            <li className="sb-li"><i /> Обновления цен и остатков в реальном времени</li>
                            <li className="sb-li"><i /> ИИ-фильтры: вероятность выкупа, категория, скидка</li>
                            <li className="sb-li"><i /> Пуш-уведомления по вашим фильтрам</li>
                            <li className="sb-li"><i /> 0 % нагрузки — всё на наших серверах</li>
                            <li className="sb-li"><i /> Лист отслеживания любимых товаров</li>
                            <li className="sb-li"><i /> «Рубли за отзыв»: товары с бонусами WB</li>
                        </ul>
                        {/* компактная полоска чипов, чтобы «досудить» пустоту внизу */}
                        <div className="sb-chips">
                            <span className="sb-chip">Приложение</span>
                            <span className="sb-chip">Фильтры с ИИ</span>
                            <span className="sb-chip">Пуш-уведомления</span>
                            <span className="sb-chip">Слежение цен</span>
                            <span className="sb-chip">Рубли за отзыв</span>
                        </div>
                    </article>

                    {/* Справа два блока — ровно напротив main */}
                    <article className="sb-card sb-card--aside1">
                        <h3 className="sb-card-title">Каналы со скидками</h3>
                        <ul className="sb-bullets">
                            <li className="sb-li"><i /> Слив WB и Ozon раньше всех</li>
                            <li className="sb-li"><i /> Акции «Детский Мир» и др.</li>
                            <li className="sb-li"><i /> Актуальные промокоды</li>
                        </ul>
                    </article>

                    <article className="sb-card sb-card--aside2">
                        <h3 className="sb-card-title">Закрытый чат</h3>
                        <ul className="sb-bullets">
                            <li className="sb-li"><i /> ИИ-помощник 24/7 (найдет товар, сделает сводку по отзывам, даст промокоды)</li>
                            <li className="sb-li"><i /> Обмен находками и лайфхаками</li>
                            <li className="sb-li"><i /> Перепродажа уловов</li>
                        </ul>
                    </article>

                    {/* Третью карточку — на всю ширину ниже (убирает «ступеньку» и добивает пустоту) */}
                    <article className="sb-card sb-card--full">
                        <h3 className="sb-card-title">Щедрая реферальная система</h3>
                        <ul className="sb-bullets">
                            <li className="sb-li"><i /> 50 % за первую оплату, до 40 % — потом</li>
                            <li className="sb-li"><i /> Вывод от 300 ₽ на карту РФ</li>
                        </ul>
                    </article>
                </div>

            </section>

            <VideoStripe />

            <YesterdayInline />

            <footer className="sb-footer">
                © {new Date().getFullYear()} Salew Bot. Экономьте с умом. Поддержка <a href="tg://resolve?domain=salew_support">@Salew_Support</a>
            </footer>
        </div>
    );
};
export default PublicLanding;
